require("!!/home/jenkins/workspace/graylog-project-release/.dependencies/graylog2-server/graylog2-web-interface/node_modules/script-loader/addScript.js")(require("!!/home/jenkins/workspace/graylog-project-release/.dependencies/graylog2-server/graylog2-web-interface/node_modules/raw-loader/index.js!/home/jenkins/workspace/graylog-project-release/.dependencies/graylog2-server/graylog2-web-interface/public/javascripts/bootstrap.min.js"))


//////////////////
// WEBPACK FOOTER
// ../graylog2-server/graylog2-web-interface/~/script-loader!../graylog2-server/graylog2-web-interface/public/javascripts/bootstrap.min.js
// module id = 91
// module chunks = 0